/*
 * COPYRIGHT:     Copyright © 2019 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const UPLOAD_INVENTORY_LABEL = 'Upload Inventory'
export const SELECT_FILE_LABEL = 'Select File'
export const SELECT_FILE_PLACEHOLDER = '+ Drag Files Here or Click To Browse'
